<div class="debug-page">
  <div class="debug-header">
    <button mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    

    <div class="debug-title">
      <div class="title">Debug</div>
      @if (debugId) {
        <div class="id">{{ debugId }}</div>
      }
    </div>
  </div>

  <div class="debug-body">
    @if (overlayVisible) {
      <div class="loading-veil" [class.fade-out]="overlayFadingOut" aria-label="Loading debug">
        <mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner>
      </div>
    }

    @if (error) {
      <div class="state error">{{ error }}</div>
    } @else if (!doc) {
      <div class="state">No debug document.</div>
    } @else {
      <mat-form-field appearance="outline" class="filter">
        <mat-label>Filter by node</mat-label>
        <input matInput [value]="filter" (input)="onFilterChange(($any($event.target)).value)" />
      </mat-form-field>

      <div class="meta">
        <div><strong>Events:</strong> {{ filteredEvents.length }} / {{ events.length }}</div>
      </div>

      <div class="events">
        @for (event of filteredEvents; track trackByIndex($index)) {
          @if (isUserQueryEvent(event)) {
            <div class="user-query">
              <div class="user-query-header">
                <div class="user-query-title">User query</div>
                <div class="user-query-ts">{{ event.timestamp }}</div>
              </div>
              <div class="user-query-text">{{ $any(event.data)?.user_query }}</div>
            </div>
          } @else {
            <mat-expansion-panel class="panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="node">{{ event.node }}</span>
                </mat-panel-title>
                <mat-panel-description>
                  <span class="ts">{{ event.timestamp }}</span>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <pre class="json">{{ event.data | json }}</pre>
            </mat-expansion-panel>
          }
        }
      </div>
    }
  </div>
</div>

